

export const headerData = [
  {
    id: 1,
    title: "Home",
    link: "/",
  },
  {
    id: 2,
    title: "Shop",
    link: "/shop",
  },
  {
    id: 3,
    title: "About Us",
    link: "/about-us",
  },
  {
    id: 4,
    title: "Contact Us",
    link: "/contact-us",
  },
];

export const sliderData = [
  {
    id: 1,
    title: "Stylish Furnitures",
    title2: "Sustainable",
    title3: "Chairs",
    title4: "for Every Space",
    description:
      "Sodales ridiculus lacus laoreet dictum curae maximus, viverra tortor eget, rutrum enim. Vivamus sed lacus ligula. Nam malesuada pellentesque mi, non eleifend ipsum ullamcorper id. Etiam vehicula tellus sem.",
    btnTitle: "view our collection",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/09/Home-1-slider-img-01.png",
    circleText: " We make the Ordinary, Extraordinary.",
  },
  {
    id: 2,
    title: "Comfortness",
    title2: "Timeless",
    title3: "Comfort",
    title4: "In Wooden Chairs",
    description:
      "Sollicitudin condimentum ante purus libero pharetra. Eleifend tincidunt tempus elementum ad quisque. Elit tincidunt porttitor arcu scelerisque nibh sapien leo rutrum. Varius leo lacus magnis quam convallis.",
    btnTitle: "view our collection",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/home-01-slider-1.png",
    circleText: " We make the Ordinary, Extraordinary.",
  },
  {
    id: 3,
    title: "Crafting Works",
    title2: "Eco-Chic",
    title3: "Chairs",
    title4: "For All",
    description:
      "Vitae parturient ultricies. Consectetur non fermentum nisl turpis turpis facilisis. Proin duis arcu ex taciti consectetur sit tempus iaculis. Dapibus odio vehicula penatibus viverra fringilla bibendum.",
    btnTitle: "view our collection",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/home-01-slider-2.png",
    circleText: " We make the Ordinary, Extraordinary.",
  },
];

export const sliderData2 = [
  {
    id: 1,
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/09/Home-1-slider-img-03.png",
    title: "Timberly",
    title2: "Balcony Sofa",
    price: "$100.00",
    btnTitle: "Shop Now",
  },
  {
    id: 2,
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/home-01-slider-buttom-1.png",
    title: "Grainify",
    title2: "Bedside Lamp",
    price: "$90.00",
    btnTitle: "Shop Now",
  },
  {
    id: 3,
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/home-01-slider-buttom-2.png",
    title: "Twillow",
    title2: "Living Room Sofa",
    price: "$125.00",
    btnTitle: "Shop Now",
  },
];

export const sliderData3 = [
  {
    id: 1,
    link: "/",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-category-img-14.png",
    title: "Bench",
    items: "2",
  },
  {
    id: 2,
    link: "/",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-category-img-01.png",
    title: "Bookcase",
    items: "2",
  },
  {
    id: 3,
    link: "/",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-category-img-11.png",
    title: "Dining Table",
    items: "2",
  },
  {
    id: 4,
    link: "/",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/catagory-dressing-table-2.jpg",
    title: "Dressing Table",
    items: "2",
  },
  {
    id: 5,
    link: "/",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-category-img-03.png",
    title: "Office Chair",
    items: "5",
  },
  {
    id: 6,
    link: "/",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-category-img-08.png",
    title: "Sofa",
    items: "5",
  },
  {
    id: 7,
    link: "/",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-category-img-02.png",
    title: "Study Table",
    items: "5",
  },
  {
    id: 8,
    link: "/",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-category-img-09.png",
    title: "Stylish Furniture",
    items: "6",
  },
  {
    id: 9,
    link: "/",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-category-img-12.png",
    title: "Wardrobe",
    items: "5",
  },
  {
    id: 10,
    link: "/",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-category-img-05.png",
    title: "Wooden Chair",
    items: "5",
  },
  {
    id: 11,
    link: "/",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-category-img-04.png",
    title: "Wooden Cot",
    items: "5",
  },
  {
    id: 12,
    link: "/",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-category-img-06.png",
    title: "Wooden Table",
    items: "5",
  },
  {
    id: 13,
    link: "/",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-category-img-07.png",
    title: "Wooden Lamp",
    items: "5",
  },
];

export const collectionData = [
  {
    id: 1,
    category: "allfurniture",
    label: "New",
    link: "/",
    name: "Solid Wood Chair",
    price: "80.00",
    price2: "75.00",
    rating: "4",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/ff-shop-product-1-01.png",
  },
  {
    id: 2,
    category: "allfurniture",
    label: "",
    link: "/",
    name: "Garden Chair",
    price: "70.00",
    price2: "102.00",
    rating: "4",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-3-01.png",
  },
  {
    id: 3,
    category: "allfurniture",
    label: "",
    link: "/",
    name: "Table Lamp",
    price: "60.00",
    price2: "55.00",
    rating: "4",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-5-01.png",
  },
  {
    id: 4,
    category: "allfurniture",
    label: "",
    link: "/",
    name: "Wooden Round Table",
    price: "80.00",
    price2: "75.00",
    rating: "4",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-6-01.png",
  },
  {
    id: 5,
    category: "allfurniture",
    label: "",
    link: "/",
    name: "Office Chair",
    price: "95.00",
    price2: "90.00",
    rating: "4",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-7-01.png",
  },
  {
    id: 6,
    category: "allfurniture",
    label: "",
    link: "/",
    name: "Wooden Garden Bench",
    price: "115.00",
    price2: "110.00",
    rating: "4",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-31-01.png",
  },
  {
    id: 7,
    category: "allfurniture",
    label: "",
    link: "/",
    name: "Stylish Comfort Bed",
    price: "185.00",
    price2: "180.00",
    rating: "4",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-31-01.png",
  },
  {
    id: 8,
    category: "allfurniture",
    label: "New",
    link: "/",
    name: "Two Seater Sofa",
    price: "115.00",
    price2: "140.00",
    rating: "4",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-37-01.png",
  },
  {
    id: 9,
    category: "bestseller",
    label: "",
    link: "/",
    name: "Wooden Garden Bench",
    price: "115.00",
    price2: "110.00",
    rating: "5",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-38-01.png",
  },
  {
    id: 10,
    category: "bestseller",
    label: "New",
    link: "/",
    name: "Comfort Sofa",
    price: "130.00",
    price2: "150.00",
    rating: "5",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-34-01.png",
  },
  {
    id: 11,
    category: "bestseller",
    label: "",
    link: "/",
    name: "Leather Office Chair",
    price: "90.00",
    price2: "85.00",
    rating: "4",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-11-01.png",
  },
  {
    id: 12,
    category: "bestseller",
    label: "",
    link: "/",
    name: "Teak Dining Table",
    price: "95.00",
    price2: "90.00",
    rating: "4",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-25-01.png",
  },
  {
    id: 13,
    category: "bestseller",
    label: "",
    link: "/",
    name: "Office Visitor Chair",
    price: "75.00",
    price2: "70.00",
    rating: "3",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-15-01.png",
  },
  {
    id: 14,
    category: "bestseller",
    label: "",
    link: "/",
    name: "Comfortable Mattress",
    price: "155.00",
    price2: "150.00",
    rating: "5",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-17-01.png",
  },
  {
    id: 15,
    category: "bestseller",
    label: "",
    link: "/",
    name: "Wooden Desk And Chair",
    price: "85.00",
    price2: "80.00",
    rating: "5",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-16-01.png",
  },
  {
    id: 16,
    category: "bestseller",
    label: "",
    link: "/",
    name: "Spring Mattress",
    price: "165.00",
    price2: "160.00",
    rating: "5",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-18-01.png",
  },
  {
    id: 17,
    category: "newarrival",
    label: "",
    link: "/",
    name: "Solid Wood Chair",
    price: "80.00",
    price2: "75.00",
    rating: "5",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/ff-shop-product-1-01.png",
  },
  {
    id: 18,
    category: "newarrival",
    label: "",
    link: "/",
    name: "Living Room Chair",
    price: "125.00",
    price2: "120.00",
    rating: "5",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-2-01.png",
  },
  {
    id: 19,
    category: "newarrival",
    label: "",
    link: "/",
    name: "Garden Chair",
    price: "70.00",
    price2: "102.00",
    rating: "4",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-3-01.png",
  },
  {
    id: 20,
    category: "newarrival",
    label: "",
    link: "/",
    name: "Velvet Relaxer Sofa",
    price: "105.00",
    price2: "130.00",
    rating: "5",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-4-01.png",
  },
  {
    id: 21,
    category: "newarrival",
    label: "",
    link: "/",
    name: "Table Lamp",
    price: "60.00",
    price2: "55.00",
    rating: "4",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-5-01.png",
  },
  {
    id: 22,
    category: "newarrival",
    label: "",
    link: "/",
    name: "Wooden Round Table",
    price: "80.00",
    price2: "75.00",
    rating: "4",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-6-01.png",
  },
  {
    id: 23,
    category: "newarrival",
    label: "",
    link: "/",
    name: "Office Chair",
    price: "95.00",
    price2: "90.00",
    rating: "4",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-7-01.png",
  },
  {
    id: 24,
    category: "newarrival",
    label: "Sale",
    link: "/",
    name: "Modern Wooden Stool",
    price: "40.00",
    price2: "35.00",
    rating: "5",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-8-01.png",
  },
];

export const staticBannerImageArr = [
  "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-filller-slider-bg-01.jpg",
  "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-filller-slider-bg-06.jpg",
  "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-filller-slider-bg-04.jpg",
  ,
];

export const productsData = [
  {
    id: 1,
    offer: "8.3",
    title: "Stylish Outdoor Sofa",
    category: "Stylish Furniture",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/product-1.jpg",
    priceOld: 95.0,
    priceNew: 89.0,
    link: "https://furniforma.wpengine.com/product/stylish-outdoor-sofa/",
  },
  {
    id: 2,
    offer: "8.3",
    title: "Handmade Wooden Chair",
    category: "Stylish Furniture",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/product-2.jpg",
    priceOld: 75.0,
    priceNew: 70.0,
    link: "https://furniforma.wpengine.com/product/handmade-wooden-chair/",
  },
  {
    id: 3,
    offer: "2",
    title: "Decorative Light",
    category: "Stylish Furniture",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/product-3.jpg",
    priceOld: 25.0,
    priceNew: 20.0,
    link: "https://furniforma.wpengine.com/product/handmade-wooden-chair/",
  },
  {
    id: 4,
    offer: "8",
    title: "Cushion Lounge Chair",
    category: "Stylish Furniture",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/product-4.jpg",
    priceOld: 85.0,
    priceNew: 80.0,
    link: "https://furniforma.wpengine.com/product/handmade-wooden-chair/",
  },
  {
    id: 5,
    offer: "5.9",
    title: "Stylish Comfort Chair",
    category: "Stylish Furniture",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/product-5.jpg",
    priceOld: 85.0,
    priceNew: 80.0,
    link: "https://furniforma.wpengine.com/product/handmade-wooden-chair/",
  },
  {
    id: 6,
    offer: "6.7",
    title: "Curved Lounge Chair",
    category: "Stylish Furniture",
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/product-2.jpg",
    priceOld: 75.0,
    priceNew: 70.0,
    link: "https://furniforma.wpengine.com/product/handmade-wooden-chair/",
  },
];

export const reviewsData = [
  {
    id: 1,
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/testimonial-img-01.jpg",
    productName: "Luxury Leather Sofa",
    price: "270.00",
    description:
      ' Sem elit at laoreet placerat congue urna sem. <strong>" Awesome Team"</strong> Nam luctus mauris nostra nisl lacinia elit penatibus senectus. Habitant etiam velit praesent, ridiculus consequat in natoque amet. Sodales porttitor quisque tellushimenaeos justo justo luctus enim taciti.',
    profile:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/09/Home-1-Testimonial-img-01.jpg",
    name: "Sofia Rose",
    designation: "HR",
  },
  {
    id: 2,
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/testimonial-img-02.jpg",
    productName: "Elegant Round Sofa",
    price: "150.00",
    description:
      '  Etiam cursus id cubilia quis, donecfacilisis. Finibus a habitant lacus id necleo viverra natoque.{" "}<strong>" Amazing Deals "</strong> Cursusante magna laoreet mollis malesuada ut.Proin feugiat facilisi luctus orciinterdum. Blandit massa himenaeos mattis,sem dis at. Ligula litora dictumstcurabitur sagittis, quisque cras augue.',
    profile:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/client-profile-01.jpg",
    name: "Jasper Lee",
    designation: "Developer",
  },
  {
    id: 3,
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/testimonial-img-03.jpg",
    productName: "Elegant Shell Chair",
    price: "57.00",
    description:
      'Nunc scelerisque sollicitudin gravida orciegestas bibendum litora. Integer magnisvestibulum fringilla ad convallismaecenas. <strong>" Good Choice "</strong>{" "}Class eu maximus massa ut interdum;nascetur conubia. Metus scelerisque duimassa tempus mollis volutpat commodo.Iaculis libero ut leo; duis imperdiet ut.',
    profile:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/client-profile-02.jpg",
    name: "Elena Marie",
    designation: "Designer",
  },
  {
    id: 4,
    image:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/testimonial-img-04.jpg",
    productName: "Glass Round Tabl",
    price: "240.00",
    description:
      'Dictum fusce habitant torquent imperdietpenatibus himenaeos. At aliquet ex, tortorduis tellus eget. Tortor tellus etiamfames nascetur magna commodo sollicitudinmontes. <strong>" Nice Product"</strong>{" "}Fames volutpat montes lacinia erat sempurus suspendisse habitant justo. Variuslacus congue tincidunt hac rutrum et,tincidunt pellentesque.',
    profile:
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/client-profile-03.jpg",
    name: "Maya Belle",
    designation: "Manager",
  },
];

export const shopProductData = [
  {
    id: 1,
    category: "Sofa",
    subTitle: "Casandra lifestyle",
    link: "/",
    name: "Garden Chair",
    noOfReviews: "1",
    rating: "4",
    price: "70.00",
    price2: "102.00",
    color: ["black", "brown", "red"],
    stock: 150,
    image: [
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-3-01.png",
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-3-02.png",
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-3-03.png",
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-3-04.png",
    ],
  },
  {
    id: 2,
    category: "Sofa",
    subTitle: "Casandra lifestyle",
    link: "/",
    name: "Comfort Sofa",
    noOfReviews: "1",
    rating: "4",
    price: "130.00",
    price2: "150.00",
    color: ["black", "brown", "red"],
    stock: 150,
    image: [
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-34-01.png",
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-34-02.png",
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-34-03.png",
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-34-04.png",
    ],
  },
  {
    id: 3,
    category: "Sofa",
    subTitle: "Casandra lifestyle",
    link: "/",
    name: "Adjustable Folding Table",
    noOfReviews: "1",
    rating: "4",
    price: "50.00",
    price2: "45.00",
    color: ["black", "brown", "red"],
    stock: 99,
    image: [
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-13-01.png",
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-13-02.png",
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-13-03.png",
      "https://furniforma.wpengine.com/wp-content/uploads/2024/12/FF-product-img-13-04.png",
    ],
  },
];


export const testimonialData = [
  {
    id: 1, 
    image: "https://furniforma.wpengine.com/wp-content/uploads/2024/09/ConCho-H4-Testi-Img-02.jpg",
    content: "Ultricies ac dui nullam duis montes natoque dignissim quis. Velit egestas morbi vehicula montes, dignissim dolor. Sociosqu placerat felis euismod viverra, parturient inceptos ipsum eleifend amet; sit nam blandit quis.",
    name: "Amanda Rebecca",
    desgination: "Manager"
  },
  {
    id: 2, 
    image: "https://furniforma.wpengine.com/wp-content/uploads/2024/09/ConCho-H4-Testi-Img-01.jpg",
    content: "Pellentesque cursus fringilla vulputate mi tempus habitasse.bibendum. Egestas tristique imperdiet adipiscing curae luctus, primis sapien ante commodo.Consequat at mi faucibus fusce porta rhoncus elit arcu.",
    name: "Cynthia Mikias",
    desgination: "Manager"
  },
  {
    id: 3, 
    image: "https://furniforma.wpengine.com/wp-content/uploads/2024/09/Testimonial-1.jpg",
    content: "Bibendum class laoreet consectetur praesent. Convallis pharetra magnis potenti vel ante eleifend primis senectus. Dapibus non habitasse maximus vulputate enim faucibus. Est parturient leo fermentum sollicitudin porta.",
    name: "Johan",
    desgination: "Manager"
  },
  {
    id: 4, 
    image: "https://furniforma.wpengine.com/wp-content/uploads/2024/09/Testimonial-2.jpg",
    content: "Semper non purus velit semper curae. Molestie quis maecenas ex non; habitant sit feugiat. Morbi quis ex; elit nam diam suscipit suspendisse. Tempus nam turpis nunc dolor cubilia eros diam nulla placerat.",
    name: "Mathew",
    desgination: "Engineer"
  },
]